import type { EvalThresholds } from "./eval";

export type MoveCategory = "brilliant" | "great" | "best" | "inaccuracy" | "miss" | "blunder";

export interface ClassifyMoveInput {
  bestWinPercent: number;
  playedWinPercent: number;
  isBestMove: boolean;
  isOnlyMove: boolean;
  isSacrifice: boolean;
  thresholds?: EvalThresholds;
}

const DEFAULT_THRESHOLDS: EvalThresholds = {
  blunderWinPercentDrop: 20,
  inaccuracyWinPercentDrop: 10,
  missWinPercentDrop: 5,
};

export function classifyMove(input: ClassifyMoveInput): MoveCategory {
  if (input.isBestMove) {
    if (input.isSacrifice) return "brilliant";
    if (input.isOnlyMove) return "great";
    return "best";
  }

  const blunderDrop = input.thresholds?.blunderWinPercentDrop ?? DEFAULT_THRESHOLDS.blunderWinPercentDrop;
  const inaccuracyDrop =
    input.thresholds?.inaccuracyWinPercentDrop ?? DEFAULT_THRESHOLDS.inaccuracyWinPercentDrop;
  const missDrop = input.thresholds?.missWinPercentDrop ?? DEFAULT_THRESHOLDS.missWinPercentDrop;

  const drop = input.bestWinPercent - input.playedWinPercent;
  if (drop >= blunderDrop) return "blunder";
  if (drop >= inaccuracyDrop) return "inaccuracy";
  if (drop >= missDrop) return "miss";
  return "best";
}
